<template>
    <div>
        <div v-if="!record.sent_at" class="uk-form-controls-text">(Not Sent)</div>
        <div v-else class="uk-grid uk-grid-small uk-form-controls-text">
            <div class="uk-width-2-10 lam-label-column">
                <div class="uk-form-controls-text uk-text-right">
                    Sent on
                </div>
            </div>
            <div :class="{'uk-width-4-10': sent_by_visible, 'uk-width-8-10': !sent_by_visible}">
                <form-date-input
                    id="sent_at"
                    v-model="record.sent_at"
                    name="sent_at"
                    :editable="editable"
                    :required="false"
                    :error="has_error('sent_at')"
                    @input="save_field"
                />
            </div>
            <div v-if="sent_by_visible" class="uk-width-1-10 lam-label-column">
                <div class="uk-form-controls-text uk-text-right">
                    by
                </div>
            </div>
            <div v-if="sent_by_visible" class="uk-width-3-10">
                <form-select-user
                    v-if="sent_by_visible"
                    id="sent_by"
                    name="sent_by"
                    :value="record.sent_by"
                    :editable="editable"
                    :required="false"
                    @input="save_field"
                />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
import handles_saving from "../../../mixins/HandlesSaving"

import FormDateInput from "../../../ui/FormDateInput"
import FormSelectUser from "../../../ui/FormSelectUser"

export default {
    mixins: [handles_saving],
    components: {
        FormDateInput,
        FormSelectUser
    },
    mounted () {
        this.reset_entity()
    },
    watch: {
        revisionEntity: "reset_entity"
    },
    methods: {
        reset_entity () {
            this.entity = this.revisionEntity
            this.record_id = this.record ? this.record.id : 0
        }
    },
    computed: {
        sent_by_visible () {
            return this.record && (this.is_db_admin_active || !!this.record.sent_by)
        }
    },
    props: {
        record: {
            type: Object,
            required: true
        },
        revisionEntity: {
            type: String,
            required: true
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
</script>
